import _str from "shared/util/_str";

import * as Api from "apps/passions_picker/util/web";


// ////////////////////////
// ACTION TYPES //////////
// //////////////////////

export const FETCH_PASSIONS_LIST = "PASSIONS_PICKER.FETCH_PASSIONS_LIST";
export const FETCH_PASSIONS_LIST_SUCCESS = "PASSIONS_PICKER.FETCH_PASSIONS_LIST_SUCCESS";
export const FETCH_PASSIONS_LIST_ERROR = "PASSIONS_PICKER.FETCH_PASSIONS_LIST_ERROR";

export const FETCH_PASSIONS_PICKED = "PASSIONS_PICKER.FETCH_PASSIONS_PICKED";
export const FETCH_PASSIONS_PICKED_SUCCESS = "PASSIONS_PICKER.FETCH_PASSIONS_PICKED_SUCCESS";
export const FETCH_PASSIONS_PICKED_ERROR = "PASSIONS_PICKER.FETCH_PASSIONS_PICKED_ERROR";

export const TOGGLE_PASSION_PICKED = "PASSIONS_PICKER.TOGGLE_PASSION_PICKED";

export const SAVE_PASSIONS_PICKED = "PASSIONS_PICKER.SAVE_PASSIONS_PICKED";
export const SAVE_PASSIONS_PICKED_SUCCESS = "PASSIONS_PICKER.SAVE_PASSIONS_PICKED_SUCCESS";
export const SAVE_PASSIONS_PICKED_ERROR = "PASSIONS_PICKER.SAVE_PASSIONS_PICKED_ERROR";

export const RESET_PASSIONS_PICKER = "PASSIONS_PICKER.RESET_PASSIONS_PICKER";


// ////////////////////////
// INITIAL STATE /////////
// //////////////////////

export const INITIAL_STATE = {
	passionsList: [],
	passionsListLoading: false,
	passionsListError: null,

	passionsPicked: [],
	passionsPickedLoading: false,
	passionsPickedLoadingError: null,

	passionsPickedSaving: false,
	passionsPickedSavingError: null,
};


// ////////////////////////
// REDUCER ///////////////
// //////////////////////

export function reducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case FETCH_PASSIONS_LIST: {
			return {
				...state,
				passionsListLoading: true,
				passionsListError: null,
			};
		}

		case FETCH_PASSIONS_LIST_SUCCESS: {
			// set up fields
			const { passionsList } = action.payload;

			return {
				...state,
				passionsList,
				passionsListLoading: false,
			};
		}

		case FETCH_PASSIONS_LIST_ERROR: {
			return {
				...state,
				passionsList: [],
				passionsListLoading: false,
				passionsListError: action.error,
			};
		}

		case FETCH_PASSIONS_PICKED: {
			return {
				...state,
				passionsPickedLoading: true,
				passionsPickedLoadingError: null,
			};
		}

		case FETCH_PASSIONS_PICKED_SUCCESS: {
			const { passionsPicked } = action.payload;

			return {
				...state,
				passionsPicked,
				passionsPickedLoading: false,
			};
		}

		case FETCH_PASSIONS_PICKED_ERROR: {
			return {
				...state,
				passionsPicked: [],
				passionsPickedLoading: false,
				passionsPickedLoadingError: action.error,
			};
		}

		case TOGGLE_PASSION_PICKED: {
			// Does this passion exist in our current list?
			const { passionId } = action.payload;
			let passionsPicked = [...state.passionsPicked];
			const itemIndex = passionsPicked.indexOf(passionId);

			// Not picked, pick it!
			if (itemIndex < 0) {
				passionsPicked = [
					...passionsPicked,
					passionId,
				];
			}

			// Was selected, remove it.
			else {
				passionsPicked = [
					...passionsPicked.slice(0, itemIndex),
					...passionsPicked.slice(itemIndex + 1),
				];
			}

			return {
				...state,
				passionsPicked,
			};
		}

		case SAVE_PASSIONS_PICKED: {
			return {
				...state,
				passionsPickedSaving: true,
				passionsPickedSavingError: null,
			};
		}

		case SAVE_PASSIONS_PICKED_SUCCESS: {
			return {
				...state,
				passionsPickedSaving: false,
			};
		}

		case SAVE_PASSIONS_PICKED_ERROR: {
			return {
				...state,
				passionsPickedSaving: false,
				passionsPickedSavingError: action.error,
			};
		}

		case RESET_PASSIONS_PICKER: {
			return {
				...INITIAL_STATE,
			};
		}

		default:
			return state;
	}
}


// ////////////////////////
// ACTION CREATORS ///////
// //////////////////////

export function fetchPassionsList(filterOutSelected) {
	return (dispatch) => {
		dispatch({
			type: FETCH_PASSIONS_LIST,
		});

		return Api.fetchPassionsList({ filterOutSelected })
			.then((res) => {
				if (!res.success) {
					dispatch({
						type: FETCH_PASSIONS_LIST_ERROR,
						error: _str("Oops, something went wrong!"),
					});
				} else {
					dispatch({
						type: FETCH_PASSIONS_LIST_SUCCESS,
						payload: {
							passionsList: res.passionsList,
						},
					});
				}

				return { success: res.success };
			})
			.catch((err) => {
				dispatch({
					type: FETCH_PASSIONS_LIST_ERROR,
					error: err,
				});

				console.warn("Fetch fields error:", err);

				return { success: false };
			});
	};
}

export function fetchPassionsPicked() {
	return (dispatch) => {
		dispatch({
			type: FETCH_PASSIONS_PICKED,
		});

		return Api.fetchPassionsPicked()
			.then((res) => {
				if (!res.success) {
					dispatch({
						type: FETCH_PASSIONS_PICKED_ERROR,
						error: _str("Oops, something went wrong!"),
					});
				} else {
					dispatch({
						type: FETCH_PASSIONS_PICKED_SUCCESS,
						payload: {
							passionsPicked: res.passionsPicked,
						},
					});
				}

				return { success: res.success };
			})
			.catch((err) => {
				dispatch({
					type: FETCH_PASSIONS_PICKED_ERROR,
					error: err,
				});

				console.warn("Fetch fields error:", err);

				return { success: false };
			});
	};
}

export function togglePassionPicked(passionId) {
	return {
		type: TOGGLE_PASSION_PICKED,
		payload: {
			passionId,
		},
	};
}

export function savePassionsPicked(options) {
	return (dispatch, getState) => {
		const passionsPicked = getState().passionsPicker.passionsPicked;

		dispatch({
			type: SAVE_PASSIONS_PICKED,
		});

		return Api.savePassionsPicked({ passionsPicked, options })
			.then((res) => {
				if (!res.success) {
					dispatch({
						type: SAVE_PASSIONS_PICKED_ERROR,
						error: _str("Oops, something went wrong!"),
					});
				} else {
					dispatch({
						type: SAVE_PASSIONS_PICKED_SUCCESS,
					});
				}

				return { success: res.success };
			})
			.catch((err) => {
				dispatch({
					type: SAVE_PASSIONS_PICKED_ERROR,
					error: err,
				});

				return { success: false };
			});
	};
}

export function resetPassionsPicker() {
	return {
		type: RESET_PASSIONS_PICKER,
	};
}



// WEBPACK FOOTER //
// ./src/ducks/passions_picker.js